// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/numeric/numeric.js#1 $

/**
* @ngdoc directive
* @name tcApp.directive:tcNumeric
* @description
* Number picker
*/

angular.module('tcApp')

.directive('tcNumeric', function($timeout, GlobalService) {
	return {
		restrict: 'EA',
		require: 'ngModel',
		scope: {
			fieldId: '@id'
		},
		templateUrl: 'template/numeric/numeric.html',
		link: function(scope, element, attrs, ngModelCtrl) {
			// Move template to the parent
			var deleteSymbol = '\u232B';
			var decimalSymbol = '.';
			if (GlobalService.configuration && GlobalService.configuration.currency
				&& GlobalService.configuration.currency.decimalSymbol) {
				decimalSymbol = GlobalService.configuration.currency.decimalSymbol;
			}
			// Prevent decimal in integer type fields
			if (attrs.type === 'number') decimalSymbol = '';
			
			var numericTemplate = element.children()[0];
			element[0].parentNode.appendChild(numericTemplate);
			
			scope.globalStrings = GlobalService.getGlobalStrings();
			
			var disabled = false;
			var readOnly = false;
			attrs.$observe('disabled', function(value) {
				disabled = value;
			});
			attrs.$observe('readonly', function(value) {
				readOnly = value;
			});

			// Emit an event to allow behavior in container directives (e.g. overlay)
			scope.$emit('tcNumeric:Init');
			
			var scrollNumericPadIntoView = function() {
				var numericPadElement = numericTemplate.querySelector('.numeric');
				if (!numericPadElement) return;

				GlobalService.scrollElementIntoView(element[0], numericPadElement);
			};

			scope.lookupEnabled = function() {
				return ((!disabled) && (!readOnly));
			};
			scope.toggleLookup = function() {
				if (scope.isOpen) {
					scope.closeNumeric();
				} else {
					scope.inputHeight = element[0].parentNode.offsetHeight;
					scope.justOpened = true;
					scope.isOpen = true;
					$timeout(scrollNumericPadIntoView);
				}
			};

			scope.closeNumeric = function() {
				scope.isOpen = false;
				var viewValue = ngModelCtrl.$modelValue;
				var formatters = ngModelCtrl.$formatters;
				for (var i = formatters.length - 1; i >= 0; --i) {
					viewValue = formatters[i](viewValue);
				}
				ngModelCtrl.$viewValue = viewValue;
				ngModelCtrl.$render();
			};
			
			scope.select = function(val) {
				var newVal;
				if (val == deleteSymbol) {
					newVal = '';
				} else {
					newVal = ngModelCtrl.$viewValue;
					if (!newVal) newVal = '';
					if (scope.justOpened) {
						scope.justOpened = false;
						newVal = '';
					}
					newVal += val;
				}
				ngModelCtrl.$setViewValue(newVal);
				ngModelCtrl.$commitViewValue();
				ngModelCtrl.$render();
			};
			
			scope.rows = [
				['1','2','3'],
				['4','5','6'],
				['7','8','9'],
				[decimalSymbol,'0',deleteSymbol]
			];
			
		}
	};
});
